import { UserCheck } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';

/**
 * Shown to an assistant for the whole session so it is always clear whose
 * book she is working. Renders nothing for anyone else.
 */
export const ActingForBanner = () => {
  const { user } = useAuthStore();
  const actingFor = user?.actingFor;
  if (!actingFor) return null;

  const name = actingFor.displayName?.trim();
  const text = name ? `Working ${name}'s book` : "Working your rep's book";

  return (
    <div
      role="status"
      className="sticky top-0 z-30 border-b border-blast-200 dark:border-blast-800 bg-blast-50 dark:bg-blast-950"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center gap-2 text-sm font-medium text-blast-700 dark:text-blast-300">
        <UserCheck className="h-4 w-4 flex-shrink-0" />
        <span>{text}</span>
      </div>
    </div>
  );
};
